import React from 'react';
import SEOHead from '../components/SEOHead';

const Legal: React.FC = () => {
  return (
    <div className="pt-16">
      <SEOHead title="Mentions légales" description="Mentions légales du site Doux ce Moman, centre de bien-être périnatal à Geneuille (25)." path="/mentions-legales" noindex />
      <h1>Legal Page</h1>
      <p>This page will be implemented in the next phase.</p>
    </div>
  );
};

export default Legal;